import 'overlayscrollbars/overlayscrollbars.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import store from './stores/store';
import { 
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import Layout from "./components/layout/Layout";
import RequireAuth from './components/auth/RequireAuth';
import AuthInit from './components/auth/AuthInit';
import RequireDirector from './components/auth/RequireDirector';
import RequireUnauth from './components/auth/RequireUnauth';

let persistor = persistStore(store);

const routes = createBrowserRouter(
  [
    {
      element: <AuthInit/>,
      children: [
        {
          element: <Layout/>,
          children: [
            {
              element: <RequireAuth/>,
              children: [
                {
                  path: "play",
                  lazy: () => import("./pages/protected/Play")
                },
                {
                  path: "builder",
                  lazy: () => import("./pages/protected/EmblemBuilder")
                },
                {
                  path: "guardian",
                  lazy: () => import("./pages/protected/Guardian")
                },
                {
                  path: "delete-account",
                  lazy: () => import("./pages/protected/DeleteAccount")
                },
                {
                  element: <RequireDirector/>,
                  children: [
                    {
                      path: "creator",
                      lazy: () => import("./pages/protected/TournamentCreator")
                    }
                  ]
                }
              ]
            },
            {
              element: <RequireUnauth/>,
              children: [
                {
                  path: "auth",
                  lazy: () => import("./pages/public/Authenticate")
                }
              ]
            },
            {
              index: true,
              lazy: () => import("./pages/public/Homepage")
            },
            {
              path: "faq",
              lazy: () => import("./pages/public/Faq")
            },
            {
              path: "privacy",
              lazy: () => import("./pages/public/PrivacyPolicy")
            },
            {
              path: "donations",
              lazy: () => import("./pages/public/Donate")
            },
            {
              path: "error",
              lazy: () => import("./pages/public/ServerError")
            },
            {
              path: "*",
              lazy: () => import("./pages/public/PageNotFound")
            }
          ]
        }
      ]
    }
  ]
);

const root = ReactDOM.createRoot(document.getElementById('root'));

if(process.env.NODE_ENV === "development") {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={routes}/>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );

} else {
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={routes}/>
      </PersistGate>
    </Provider>
  );
}
